export default [
    {
        path: 'app',
        name: 'CpSiteApp',
        component: () => import('@/views/cpsite/app/index')
    },
    {
        path: 'tpl',
        name: 'CpSiteTpl',
        component: () => import('@/views/cpsite/tpl/index')
    },
    {
        path: 'pack',
        name: 'CpSitePack',
        component: () => import('@/views/cpsite/pack/index')
    },
    {
        path: 'balance',
        name: 'CpSiteBalance',
        component: () => import('@/views/cpsite/balance/index')
    },
    {
        path: 'dash',
        name: 'CpSiteDash',
        component: () => import('@/views/cpsite/dash/index')
    },
    {
        path: 'trx',
        name: 'CpSiteTrx',
        component: () => import('@/views/cpsite/trx/index')
    },
    {
        path: 'send',
        name: 'CpSiteSend',
        component: () => import('@/views/cpsite/send/index')
    },
    {
        path: 'send-complete',
        name: 'CpSiteSendComplete',
        component: () => import('@/views/cpsite/send/complete/index')
    },
    {
        path: 'send-report',
        name: 'CpSiteSendReport',
        component: () => import('@/views/cpsite/send/report/index')
    },
    {
        path: 'send-report-detail/:campaign_id/:campaign_name',
        props: true,
        name: 'CpSiteSendReportDetail',
        component: () => import('@/views/cpsite/send/report/detail/index')
    },
    {
        path: 'address',
        name: 'CpSiteAddress',
        component: () => import('@/views/cpsite/address/index')
    },
    {
        path: 'address-items/:group_id/:group_name',
        props: true,
        name: 'CpSiteAddressItems',
        component: () => import('@/views/cpsite/address/items/index')
    },
];